<template>
    <div class="history-medication">
       
        <div class="medication-item">
            <p class="title">历史用药</p>
            <div class="history-form">
                <div class="form-item flexC">
                    <span class="label">{{$t("historyMedication.medicationName")}}：</span>
                    <div class="input flexC" @click="medicaltionShow = true">
                        <p class="placeholder" v-if="!formObj.medicationName">请选择</p>
                        <p class="txt" v-else>{{formObj.medicationName}}</p>
                        <van-icon name="arrow" />
                    </div>
                </div>
                <div class="form-item flexC">
                    <span class="label">{{$t("historyMedication.startTakeDate")}}：</span>
                    <div class="input flexC" @click="startTakeDateShow = true">
                        <p class="placeholder" v-if="!formObj.startTime">请选择</p>
                        <p class="txt" v-else>{{formObj.startTime}}</p>
                        <van-icon name="arrow" />
                    </div>
                </div>
                <div class="form-item flexC">
                    <span class="label">{{$t("historyMedication.dxzgc")}}：</span>
                    <div class="input flexC" >
                        <van-field v-model="formObj.takeNum" class="txt" type="digit" placeholder="请输入" />
                        <span class="unit">盒</span>
                    </div>
                </div>
                <div class="form-item flexC">
                    <span class="label">{{$t("historyMedication.mqhs")}}：</span>
                    <div class="input flexC" >
                        <van-field v-model="formObj.leftNum" class="txt" type="digit" placeholder="请输入" />
                        <span class="unit">盒</span>
                    </div>
                </div>
                <div class="form-item flexC">
                    <span class="label">{{$t("historyMedication.mqfypl")}}：</span>
                    <div class="input flexC" >
                        <div class="flexC frequency">
                            <span class="unit">早</span>
                            <van-field v-model="formObj.doseAm" type="digit" class="txt" placeholder="请输入" />
                        </div>
                        <div class="flexC frequency">
                            <span class="unit">晚</span>
                            <van-field v-model="formObj.dosePm" type="digit" class="txt" placeholder="请输入" />
                        </div>
                    </div>
                </div>
                <div class="form-btn">
                    <van-button class="btn-container" type="primary" :disabled="btnDisabled" @click="submit" block>确认提交</van-button>
                </div>
            </div>
        </div>
        <!-- 选择用药品 -->
        <van-overlay v-show="medicaltionShow" class-name="picketDate">
            <div class="null" @click="medicaltionShow=false"></div>
            <van-picker
                :title='$t("historyMedication.medicationName")'
                show-toolbar
                :columns="columns"
                @confirm="medicaltionConfirm"
                @cancel="medicaltionShow=false"
            />
        </van-overlay>
        <!-- 选择开始使用时间 -->
        <van-overlay v-show="startTakeDateShow" class-name="picketDate">
            <div class="null" @click="startTakeDateShow=false"></div>
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                :title='$t("personalDetail.selectDay")'
                :min-date="minDate"
                @confirm="dateConfirm"
                @cancel="startTakeDateShow=false"
                :max-date="maxDate"
            />
        </van-overlay>
    </div>
</template>
<script>
// 1.medication-take-log/addOrUpdate 新建和更新
// 2.medication-take-log/list   查询

//  接口1的发送参数和接口2的返回参数

//    ;//用户Id
//    ;//药物ID
//    doseAm;//目前的服药频率：早
//    dosePm;目前的服药频率：晚
//    ;//到现在一共吃掉了：
//    leftNum;//目前还剩：
//    endTime;
//    startTime;//最早开始服用的日期：
//    medicationName;//药物名称（接口1 不适用）
import { medicationTakelogQuery, drugQuery, addOrUpdataHistoryMadicaltion, getHistoryMadicaltionInfo } from "@/api/user";
import { getLocalDateTime } from "@/utils/date";
export default {
    data () {
        return {
            medicaltionShow:false,
            startTakeDateShow:false,
            currentDate:new Date(),
            medicationId:this.$route.query.medicationId,
            formObj:{
                medicationName:"",
                userId:this.$route.query.patientId,
                medicationId:"",
                doseAm:"",
                dosePm:"",
                takeNum:"",
                leftNum:"",
                endTime:"",
                startTime:"",
            },
            columns:[],
            minDate: new Date(new Date().getFullYear()-15, 0, 1),
            maxDate: new Date(new Date().getFullYear()+1,0,1),
            drugList:[],
            medicationList:[]
        }
    },
    computed: {
        btnDisabled(){
            return !(this.formObj.medicationName
                && this.formObj.startTime
                && this.formObj.takeNum
                && this.formObj.leftNum
                && this.formObj.doseAm
                && this.formObj.dosePm);
        }
    },
    created () {
        document.title = this.$t("historyMedication.supplement");
        if(this.$route.query.medicationId){
            this.getInfo()
        }
        this.getMedicationData()
    },
    methods: {
        getInfo(){
            getHistoryMadicaltionInfo({
                userId:this.formObj.userId,
                medicationId:this.medicationId
            }).then(result =>{
                if(result.data.errorCode == 0){
                    this.formObj = result.data.data;
                }
            })
        },
        dateConfirm(e){
            this.formObj.startTime = getLocalDateTime(e);
            this.startTakeDateShow = false;
        },
        submit(){
             const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            this.formObj.startTime = this.formObj.startTime.replace(/\//g,"-")
            addOrUpdataHistoryMadicaltion(this.formObj).then(result =>{
                toast.clear()
                if(result.data.errorCode == 0){
                    this.$router.go(-1)
                }else{
                    this.$toast(result.data.errorMsg)
                }
            })
        },
        medicaltionConfirm(e){
            let r = this.drugList.find(item=> item.name == e)
            this.formObj.medicationName = r.name;
            this.formObj.medicationId = r.id;
            this.medicaltionShow = false;
        },
        async getMedicationData(){
            let res = await medicationTakelogQuery({userId:this.$route.query.patientId})
            let resDrug = await drugQuery({});
                console.log(res);
            if(res.data.errorCode == 0&&resDrug.data.errorCode == 0){
                this.drugList = resDrug.data.data;
                for (let i = 0; i < resDrug.data.data.length; i++) {
                    const it = resDrug.data.data[i];
                    let r = res.data.data.find(item => item.medicationId == it.id);
                    if(!r){
                        this.columns.push(it.name)
                    }
                }
            }else{
                this.$toast(res.data.errorMsg||resDrug.data.errorMsg)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.history-medication{
    padding: 0.4rem 0.6rem;
    background: #F5F6FA;
    min-height: 100%;
    .medication-item{
        background: #fff;
        padding: 0 0.4rem;
        border-radius: 0.32rem;
        box-shadow: 0 0.12rem 0.24rem 0 #DBE1E6;
        .title{
            font-size: 0.72rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #181818;
            line-height: 1rem;
            padding: 0.6rem 0  0.6rem  0.5rem;
            position: relative;
            border-bottom: 1px solid #EDEDED;
            &::after{
                position: absolute;
                width: 0.2rem;
                height: 0.72rem;
                content: " ";
                left: 0;
                top: 50%;
                transform: translate(0,-50%);
                background: #49A7FF;
                border-radius: 0.1rem;
            }
        }
        .history-form{
            .form-item{
                padding: 0.6rem 0;
                border-bottom: 1px solid #EDEDED;
                .label{
                    flex: 0 0 auto;
                    font-size: 0.64rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #181818;
                    line-height: 0.9rem;
                }
                .input{
                    flex: 1;
                    height: 1rem;
                    justify-content: flex-end;
                    overflow: hidden;
                    p, /deep/ .van-field{
                        font-size: 0.64rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #9B9B9B;
                        flex: 1;
                        text-align: right;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .placeholder{
                        color: #9B9B9B;
                    }
                    .txt{
                        color: #181818;
                    }
                    /deep/ .van-icon-arrow{
                        font-size: 0.56rem;
                        flex: 0 0 auto;
                    }
                    .unit{
                        flex: 0 0 auto;
                        font-size: 0.56rem;
                    }
                }
            }
            .form-btn{
                padding: 0.6rem 0;
                .btn-container{
                    line-height: 1.6rem;
                    text-align: center;
                    font-size: 0.64rem;
                    color: #fff;
                    height: 1.6rem;
                    background: linear-gradient(180deg, #49C1FF 0%, #499FFF 100%);
                    border-radius: 0.8rem;
                    border:0;
                }
            }
        }
    }
}
.picketDate{
    display: flex;
    flex-direction: column;
    .null{
        flex: 1;
    }
    .van-picker {
        flex: auto 0 0;
    }
}
</style>